import React from "react";
import styled from "styled-components";

const RetailerCard = ( {handleChange}) => {
  return (
    <StyledWrapper>
      <div className="radio-inputs">
        <label className="radio">
          <input onChange={handleChange('retailer')} type="radio" name="radio" defaultChecked />
          <span className="name">Retailers</span>
        </label>
        <label  onChange={handleChange('distributor')} className="radio">
          <input type="radio" name="radio" />
          <span className="name">Distributors</span>
        </label>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .radio-inputs {
    position: relative;
    display: flex;
    border-radius: 0.5rem;
    background-color: rgb(186, 22, 33);
    box-sizing: border-box;
    font-size: 14px;
    width: 100%;
    padding: 1rem 1rem 0 1rem;
  }

  .radio-inputs .radio input {
    display: none;
  }

  .radio-inputs .radio .name {
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    border: none;
    padding: 0.5rem 0.8rem;
    color: #000000;
    transition: all 0.15s ease-in-out;
    position: relative;
  }

  .radio-inputs .radio input:checked + .name {
    background-color: #ffffff;
    font-weight: 600;
  }
  .radio-inputs .radio input + .name:hover {
    color: #fff;
  }
  .radio-inputs .radio input:checked + .name:hover {
    color: rgb(19, 1, 1);
  }

  .radio-inputs .radio input:checked + .name::after,
  .radio-inputs .radio input:checked + .name::before {
    content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    background-color: #ba1621;
    bottom: 0;
  }

  .radio-inputs .radio input:checked + .name::after {
    right: -10px;
    border-bottom-left-radius: 300px;
    box-shadow: -3px 3px 0px 3px #ffffff;
  }
  .radio-inputs .radio input:checked + .name::before {
    left: -10px;
    border-bottom-right-radius: 300px;
    box-shadow: 3px 3px 0px 3px #ffffff;
  }
`;

export default RetailerCard;
